function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useRef, useEffect } from 'react';
import { CheckBox } from 'grommet';
export const IndeterminateCheckbox = /*#__PURE__*/forwardRef(({
  indeterminate,
  className,
  ...rest
}, ref) => {
  const defaultRef = useRef();
  const resolvedRef = ref || defaultRef;
  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(CheckBox, _extends({
    onClick: e => e.stopPropagation(),
    ref: resolvedRef
  }, rest)));
});
IndeterminateCheckbox.displayName = 'IndeterminateCheckbox';